export enum InvoiceAddressActionEnum {
  CreateNew = 1,
  FromRegister = 2,
  EditExisting = 3,
}
